module.exports = __webpack_public_path__ + "static/img/product02-2.cc8dcf80.png";